import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-right",
  "use": "icon-icon-arrow-right-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"icon-icon-arrow-right\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-arrow-right .cls-1 {\r\n        fill: #459fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-arrow-right_联合_115\" data-name=\"联合 115\" class=\"cls-1\" d=\"M-3037.7-2449.14a.487.487,0,0,1,0-.676l4.574-4.684-4.574-4.685a.486.486,0,0,1,0-.675.458.458,0,0,1,.66,0l4.9,5.022a.483.483,0,0,1,.136.337.484.484,0,0,1-.136.338l-4.9,5.022a.457.457,0,0,1-.329.14A.462.462,0,0,1-3037.7-2449.14Zm-6.164,0a.487.487,0,0,1,0-.676l4.574-4.684-4.574-4.685a.486.486,0,0,1,0-.675.458.458,0,0,1,.66,0l4.9,5.022a.483.483,0,0,1,.137.337.484.484,0,0,1-.137.338l-4.9,5.022a.458.458,0,0,1-.329.14A.462.462,0,0,1-3043.864-2449.14Z\" transform=\"translate(3044 2460)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-arrow-right.svg
// module id = LZYl
// module chunks = 3